import { render, staticRenderFns } from "./kycg.vue?vue&type=template&id=1693abd4&"
import script from "./kycg.vue?vue&type=script&lang=js&"
export * from "./kycg.vue?vue&type=script&lang=js&"
import style0 from "./kycg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports